import React, {Fragment, useEffect, useState} from "react";
import useModalLearningJournal, {LearningJournalModalModes} from "../../Modals/ModalLearningJournal/useModalLearningJournal";
import S360WidgetContainer from "root/s360components/LearningJournal/S360WidgetContainer";
import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import 'react-datepicker/dist/react-datepicker.css';
import '../../ReactHookForm/ui/DatePickerControl.scss';
import parse from "date-fns/parse";
import format from "date-fns/format";
import startOfWeek from 'date-fns/startOfWeek'
import endOfWeek from 'date-fns/endOfWeek'
import {useForm} from "react-hook-form";
import HookSubFormGroupAndPupil, {groupAndChild} from "root/s360components/LearningJournal/HookSubFormGroupAndPupil";
import HookSubFormDateRangeSelector, {dateRange} from "root/s360components/LearningJournal/HookSubFormDateRangeSelector";
import HookSubFormParentSelector, {parentFields} from "root/s360components/LearningJournal/HookSubFormParentSelector";
import HookSubFormCoelAndALD, {coelAndALD} from "root/s360components/LearningJournal/HookSubFormCoelAndALD";
import HookSubFormParentPupils from "root/s360components/LearningJournal/HookSubFormParentPupils";

export const FormSectionNames = {
    COEL: 'coel',
    DATE_RANGE: 'date_range',
    GROUP_AND_CHILD: 'group_and_child',
    FILTERS: 'filters'
} ;
const LearningJournalPage = ({school_id}) =>
{
    const [ customStartDate, setCustomStartDate] = useState ( null ) ;
    const [ customEndDate, setCustomEndDate] = useState ( null ) ;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const reportType = urlParams.get('report');
    const menu = urlParams.get('menu');

    const flagOptions = {
        LearningJournal: {
            scope: 'learningJournal',
            showPupilSection: true,
            isParentSelection: false,
            showALD: true,
            learningJournalOnly: true,
            onlyShowParentObservations: false
        },
        LearningJournalParent: {
            scope: 'learningJournal',
            showPupilSection: true,
            isParentSelection: true,
            showALD: false,
            learningJournalOnly: true,
            onlyShowParentObservations: false
        },
        AllObservations: {
            scope: 'all',
            showPupilSection: true,
            isParentSelection: false,
            showALD: true,
            learningJournalOnly: false,
            onlyShowParentObservations: false
        },
        ParentObservations: {
            scope: 'parent',
            showPupilSection: true,
            isParentSelection: false,
            showALD: false,
            learningJournalOnly: true,
            onlyShowParentObservations: true //Overriding flag
        },
        default : {
            scope: 'parent',
            showPupilSection: true,
            showALD: true,
            learningJournalOnly: true,
            onlyShowParentObservations: false
        }
    }

    const flags = flagOptions[reportType] === undefined ? flagOptions.default : flagOptions[reportType] ;

    const {register, control, handleSubmit, setFocus, watch, setValue, getValues, reset, resetField, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                ... groupAndChild(),
                ... dateRange(),
                ... parentFields(),
                ... coelAndALD(),
            }
        });

    const controlProps = {
        control: control,
        register: register,
        watch: watch,
        reset: reset,
        resetField: resetField,
        formErrors: formErrors,
        setValue: setValue,
        getValues: getValues
    }

    useEffect(() => {
        const [ initStart, initEnd ] = getCurrentYearStartAndEnd() ;

        setCustomStartDate( initStart ) ;
        setCustomEndDate( initEnd ) ;

    }, []);

    const [ renderJournalModal, activateJournal ] = useModalLearningJournal((status) =>
    {
        console.log ( status ) ;
    });

    const getCurrentYearStartAndEnd = () =>
    {
        const now = new Date() ;

        const month = Number(format(now, 'MM')) ;
        const year = Number(format(now, 'y')) ;

        const academicYear = ( month >= 1 && month <= 9 ) ? year - 1 : year ;

        const startStr = '01/09/' + academicYear ;
        const endStr = '31/08/' + ( academicYear + 1 );

        const dt_start = parse(startStr, 'dd/MM/yyyy', new Date());
        const dt_end = parse(endStr, 'dd/MM/yyyy', new Date());

        return [ dt_start, dt_end ] ;
    }

    const getCurrentWeekStartAndEnd = () =>
    {
        const now = new Date() ;

        const dt_start = startOfWeek(now, { weekStartsOn: 1 } ) ;
        const dt_end = endOfWeek(now, { weekStartsOn: 1 } ) ;

        return [ dt_start, dt_end ] ;
    }

    const onChangeEnd = ( newFilter ) =>
    {
        setCustomEndDate( newFilter )
    }

    const onChangeTerm = ( newFilter ) =>
    {
        const start_str = newFilter.date_from ;
        const end_str = newFilter.date_to ;

        const dt_start = parse(start_str, 'dd/MM/yyyy', new Date());
        const dt_end = parse(end_str, 'dd/MM/yyyy', new Date());

        setCustomStartDate( dt_start );
        setCustomEndDate( dt_end );
    }

    const runEnabled = userId !== null ;

    const processMultiArray = ( rows ) =>
    {
        const includesAll = rows.reduce ((acc,cur) =>
        {
            return ( cur.value === 0 || acc === true ) ;
        }, false) ;

        if ( includesAll === true )
        {
            return [0] ;
        }
        else
        {
            return rows.reduce((acc, cur) =>
            {
                if ( cur.value !== 0 )
                {
                    acc.push ( cur.value ) ;
                }

                return acc;
            }, []);
        }
    }

    const onSubmit = (data) =>
    {
        //setButtonsDisabled( true ) ;
        console.log ( data ) ;

        const dt_start = format(data.date_range.start_date, 'yyyy-MM-dd', new Date());
        const dt_end = format(data.date_range.end_date, 'yyyy-MM-dd', new Date());

        const child_id = data.group_and_child.child_id.value ;

        const includeParentObs = data.filters.parent_obs ;
        const includeALDs = data.filters.show_coel ;

        const onlyShowParentObservations = flags.onlyShowParentObservations;
        const learningJournalOnly = flags.learningJournalOnly ;

        const aldArray = processMultiArray ( data[FormSectionNames.COEL].ald ) ;
        const coelArray = processMultiArray ( data[FormSectionNames.COEL].coel ) ;

        activateJournal ( {
            mode: LearningJournalModalModes.SELECT,
            child_id: child_id, learning_journal_ald: 'all',
            flags: {
                includeParentObs: includeParentObs,
                includeALDs: includeALDs,
                includeDetailHeadings: false,
                learningJournalOnly: learningJournalOnly,
                onlyShowParentObservations: onlyShowParentObservations
            },
            alds: aldArray,
            coels: coelArray,
            date_from: dt_start, date_to: dt_end } ) ;
    }

    const onClickSaveForm = (status) =>
    {
        const cur = getValues();

        console.log ( cur ) ;

        handleSubmit(onSubmit)(status);
    }

    const isParentSelection = flags.isParentSelection ;

    const backLink = "/eyfs_admin.php?page=form_eyfs_progress_reports_n3&menu=" + menu;

    return (
        <S360WidgetContainer style={{minHeight: '600px'}}>

            <form className='' onSubmit={handleSubmit(onSubmit)}>
                { isParentSelection === false && <HookSubFormGroupAndPupil school_id={school_id} readOnly={false}  {...controlProps} sectionName={FormSectionNames.GROUP_AND_CHILD} /> }
                { isParentSelection === true && <HookSubFormParentPupils readOnly={false}  {...controlProps} sectionName={FormSectionNames.GROUP_AND_CHILD} /> }
                <HookSubFormDateRangeSelector readOnly={false} {...controlProps} sectionName={FormSectionNames.DATE_RANGE} />
                { flags.showALD === true && <HookSubFormCoelAndALD readOnly={false} {...controlProps} sectionName={FormSectionNames.COEL} /> }
                {flags.onlyShowParentObservations === false && <HookSubFormParentSelector readOnly={false} {...controlProps} sectionName={FormSectionNames.FILTERS} />}

                <BootstrapRow>
                    <BootstrapCol width={12}>
                        <div className='modal-button-row'>
                            <a href={backLink}><button type="button" className="btn btn-primary btn-icon glyphicons leaf"><i></i>Back</button></a>
                            <button disabled={!runEnabled && false } type="button" className="btn btn-success btn-icon glyphicons leaf" onClick={onClickSaveForm}><i></i>Run Journal Generator</button>
                        </div>
                    </BootstrapCol>
                </BootstrapRow>

                { renderJournalModal() }
            </form>

            { /* <S360WidgetBlock title='Select a Group/Pupil'>
                <BootstrapRow>
                    <BootstrapCol width={6}>
                        <DropdownProviderEYFSGroups provider_id={524553} onChange={onChangeGroup}/>
                    </BootstrapCol>
                    <BootstrapCol width={6}>
                        <DropdownProviderEYFSGroupMembers enc_group_id={groupId} readOnly={groupId === null} onChange={onChangeChild}/>
                    </BootstrapCol>
                </BootstrapRow>
            </S360WidgetBlock>
            <S360WidgetBlock title='Select the date range'>
                <BootstrapRow>
                    <BootstrapCol width={12}>
                        <FilterPicker initialValue={0} name='dashboard' values={values} onChange={onChangeFilter}/>
                    </BootstrapCol>
                </BootstrapRow>
                { termFilter === JournalFilters.TERM && <BootstrapRow>
                    <BootstrapCol width={12}>
                        <DropdownYearTerms academic_year='current' placeholder='Pick a term' onChange={onChangeTerm}/>
                    </BootstrapCol>
                </BootstrapRow> }
                { termFilter === JournalFilters.CUSTOM && <BootstrapRow>
                    <BootstrapCol width={6} style={{marginTop: '15px'}}>
                        <div className='date-wrapper'>
                            <DatePicker
                                placeholderText='Pick a start date'
                                selected={customStartDate}
                                onChange={onChangeStart}
                                disabled={readOnly}
                                wrapperClassName="datePicker"
                                dateFormat="dd/MM/yyyy"
                                dateFormatCalendar="MMMM"
                                showYearDropdown
                                showTimeInput={false}
                                yearDropdownItemNumber={30}
                                scrollableYearDropdown
                            />
                        </div>
                    </BootstrapCol>
                    <BootstrapCol width={6} style={{marginTop: '15px'}}>
                        <div className='date-wrapper'>
                            <DatePicker
                                placeholderText='Pick an End Date'
                                selected={customEndDate}
                                onChange={onChangeEnd}
                                disabled={readOnly}
                                wrapperClassName="datePicker"
                                dateFormat="dd/MM/yyyy"
                                dateFormatCalendar="MMMM"
                                showYearDropdown
                                showTimeInput={false}
                                yearDropdownItemNumber={30}
                                scrollableYearDropdown
                            />
                        </div>
                    </BootstrapCol>
                </BootstrapRow> }

                <BootstrapRow>
                    <BootstrapCol width={12} style={{marginTop: '15px'}}>
                        <button disabled={!runEnabled} type="button"  className="btn btn-success btn-icon glyphicons leaf" onClick={onClickJournalPDF}><i></i>Run Journal Generator</button>
                    </BootstrapCol>
                </BootstrapRow>
                { renderJournalModal() }

            </S360WidgetBlock> */ }
        </S360WidgetContainer>
    )
}

export default LearningJournalPage ;
